import PropTypes from "prop-types";

// material-ui
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";

// project imports
// third-party
import SimpleBar from "simplebar-react";
import {BrowserView, MobileView} from "react-device-detect";

// root style
const RootStyle = styled(BrowserView)({
    flexGrow: 1,
    height: "100%",
    overflow: "hidden",
});

// scroll bar wrapper
const SimpleBarStyle = styled(SimpleBar)(({theme}) => ({
    maxHeight: "100%",
    "& .simplebar-scrollbar": {
        "&.simplebar-visible:before": {
            opacity: 1,
        },
    },
    "& .simplebar-track": {
        "&.simplebar-vertical": {
            width: 10,
        },
    },
    "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
        height: 6,
    },
    "& .simplebar-mask": {
        zIndex: "inherit",
    },
}));

// ==============================|| SIMPLE SCROLL BAR ||============================== //

export default function SimpleBarScroll({children, sx, ...other}) {
    return (
        <>
            <RootStyle>
                <SimpleBarStyle
                    clickOnTrack={false}
                    sx={sx}
                    data-simplebar-direction="ltr"
                    {...other}
                >
                    {children}
                </SimpleBarStyle>
            </RootStyle>
            <MobileView>
                <Box sx={{overflowX: "auto", ...sx}} {...other}>
                    {children}
                </Box>
            </MobileView>
        </>
    );
}

SimpleBarScroll.propTypes = {
    children: PropTypes.any,
    sx: PropTypes.any,
    other: PropTypes.any,
};
